module.exports = __webpack_public_path__ + "img/微信图片_20251028123250_210_595.bb8316e5.jpg";